
const checkPermissionDataAvailable = (object, permission) => {
    if( !object ) return false;
    if( !object.permissions ) return false;
    if( !object.permissions[permission] ) return false;

    return true;
}


const can = (object, permission) => {
    if( !checkPermissionDataAvailable(object, permission) ) {
        return false;
    }
    return object.permissions[permission].can
}

const rulesPass = (object, permission) => {
    if( !checkPermissionDataAvailable(object, permission) ) {
        return false;
    }
    return object.permissions[permission].rulesPass
}

const canAndRulesPass = (object, permission) => {
    return can(object, permission) && rulesPass(object, permission);
}


const permissions = {
    CARD: {
        CREATE: 'card.create',
        UPDATE_INFO: 'card.update_info',
        EXPORT: 'card.export',
        SEE_COMMENTS: 'card.see_comments',
        LIST: 'card.list',
        LIST_DELETED: 'card.list_deleted',
        SEE_FIRED_USER: 'card.see_fired_users',
    },
    CARD_STAGE: {
        SEE: 'card_stage.see',
        CREATE_DYNAMIC: 'card_stage.create_dynamic',
        SET_DATE: 'card_stage.set_date',
        DELETE: 'card_stage.delete',
    },
    CARD_STAGE_NEGOTIATION: {
        CREATE: 'card_stage_negotiation.create',
        UPDATE: 'card_stage_negotiation.update',
        DELETE: 'card_stage_negotiation.delete',
        MOVE: 'card_stage_negotiation.move',
        SET_AS_CURRENT: 'card_stage_negotiation.set_as_current',
    },
    CARD_ELEMENT: {
        CREATE: 'card_element.create',
        UPDATE: 'card_element.update',
        DELETE: 'card_element.delete',
    },
    COMMENT: {
        SEE: 'comment.see',
        CREATE: 'comment.create',
        DELETE: 'comment.delete',
        UPDATE: 'comment.update',
    },
    GROUP: {
        LIST: 'group.list',
        CREATE: 'group.create',
        UPDATE: 'group.update',
        DELETE: 'group.delete',
    },
    SETTING: {
        LIST: 'setting.list',
        UPDATE: 'setting.update',
    },
    RBAC: {
        LIST: 'rbac.list',
        SET_PERMISSION: 'rbac.set_permission',
        ROLE_CREATE: 'rbac.role_create',
        ROLE_UPDATE: 'rbac.role_update',
        ROLE_DELETE: 'rbac.role_delete',
        MANAGE_USERS: 'rbac.manage_users',
    },
    LIBRARY: {
        SEE_IN_MENU: 'library.see_in_menu',

        FOLDER_LIST: 'library.folder_list',
        FOLDER_CREATE: 'library.folder_create',
        FOLDER_UPDATE: 'library.folder_update',
        FOLDER_DELETE: 'library.folder_delete',
        FOLDER_DUPLICATE: 'library.folder_duplicate',
        FOLDER_EXPORT: 'library.folder_export',
        FOLDER_EDIT_VQB: 'library.folder_edit_vqb',

        ELEMENT_LIST: 'library.element_list',
        ELEMENT_CREATE: 'library.element_create',
        ELEMENT_UPDATE: 'library.element_update',
        ELEMENT_DELETE: 'library.element_delete',
        ELEMENT_SEE_HISTORY: 'library.element_see_history',
        ELEMENT_IMPORT: 'library.element_import',
    },
    REPORT: {
        USE: 'report.use',
    },
    MATRIX: {
        VIEW: 'matrix.view',
    },
    MASS_ACTIONS: {
        CREATE: 'mass_actions.create',
    },
    USER: {
        // SEE_HOME_CHARTS: 'user.see_home_charts'
        ORGSTRUCT_VIEW: 'user.orgstruct_view',

        CHIEFS_LIST_BY_TYPE: 'user.chiefs_list_by_type',
        CHIEFS_SET: 'user.chiefs_set',
        CHIEFS_ADD_USER: 'user.chiefs_add_user',
        CHIEFS_DELETE_USER: 'user.chiefs_delete_user',

        DEPUTIES_SEE_IN_MENU: 'user.deputies_see_in_menu',
        DEPUTIES_CREATE: 'user.deputies_create',
        DEPUTIES_DELETE: 'user.deputies_delete',
        DEPUTIES_LOGIN: 'user.deputies_login',
    },
    CARD_CREATE_TEMPLATES: {
        LIST: 'card_create_template.list',
        CREATE: 'card_create_template.create',
        UPDATE: 'card_create_template.update',
        DELETE: 'card_create_template.delete',
    },
    CONFIGURABLE_SCALES: {
        SEE_IN_MENU: 'configurable_scales.see_in_menu',
        CREATE: 'configurable_scales.create',
        UPDATE: 'configurable_scales.update',
        DELETE: 'configurable_scales.delete',
    },
    HOME_DASHBOARD: {
        SEE_IN_MENU: 'home_dashboard.dashboard_see_in_menu',
        DASHBOARD_MANAGE: 'home_dashboard.dashboard_manage',
        STANDARD_DASHBOARD_MANAGE: 'home_dashboard.standard_dashboard_manage',
        WIDGET_MANAGE: 'home_dashboard.widget_manage',
    },
    CASCADING: {
      SEE_IN_MENU: 'cascading.see_in_menu',
    },
}

export default {
    install(Vue) {
        Vue.prototype.$permissions = permissions;
        Vue.prototype.$can = can;
        Vue.prototype.$rulesPass = rulesPass;
        Vue.prototype.$canAndRulesPass = canAndRulesPass;
    }
}